// removed by extract-text-webpack-plugin
module.exports = {"email-campaign-input-row":"emailCampaign__email-campaign-input-row___rJQ0l","email-campaign-orange-color":"emailCampaign__email-campaign-orange-color___aI4MY","email-campaign-red-color":"emailCampaign__email-campaign-red-color___2fmMm","email-campaign-banner":"emailCampaign__email-campaign-banner___1Kp-v"};


//////////////////
// WEBPACK FOOTER
// ./src/views/email/emailCampaign/emailCampaign.less
// module id = 200
// module chunks = 3